/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const DropletAddBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><path fillRule="evenodd" clipRule="evenodd" d="M16.5 15.877C16.5 18.043 14.6 20 12 20s-4.5-1.957-4.5-4.123c0-1.618.93-4.102 2.263-6.707a55.208 55.208 0 0 1 2.11-3.728.149.149 0 0 1 .254 0 55.203 55.203 0 0 1 2.11 3.728c1.334 2.605 2.263 5.09 2.263 6.707Zm-11 0c0-3.706 3.427-9.563 5.305-12.494l.06-.093c.272-.424.51-.782.695-1.06a.534.534 0 0 1 .88 0c.186.278.423.636.696 1.06l.06.093c1.877 2.93 5.304 8.788 5.304 12.494C18.5 19.259 15.59 22 12 22s-6.5-2.741-6.5-6.123Zm7.22 1.106v-1.25H14a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5h-1.28v-1.25a.5.5 0 0 0-.5-.5h-.5a.5.5 0 0 0-.5.5v1.25H10a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h1.22v1.25a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5Z" /></svg>);
const DropletAdd = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={DropletAddBase} {...rest} ref={ref} />);
export default DropletAdd;